import React, { useState, useEffect, useCallback } from 'react';

import WishesItem from './WishesItem';
import { styButtonWrapper } from './styles';
import { Link } from 'gatsby';
import { string } from 'prop-types';

const INTERVAL_SLIDE = 35000;

function WishesContainer( {codeLink} ) {
  const [active, setActive] = useState(0);
  const [pauseSlide, setPauseSlide] = useState(false);
  const [mensajes, setMensajes] = useState([]);
  const [load, setLoad] = useState(true);

  const handleSetActive = (isNext = true) => {
  const totalWishes = mensajes.length || 0;
    if (isNext) {
      if (active === totalWishes - 1) {
        setActive(0);
      } else {
        setActive(active + 1);
      }
    } else {
      if (active === 0) {
        setActive(totalWishes - 1);
      } else {
        setActive(active - 1);
      }
    }

    setPauseSlide(true);

    setTimeout(() => {
      setPauseSlide(false);
    }, INTERVAL_SLIDE);
  };

  const handleSetNext = useCallback(() => {
    if (active === mensajes.length - 1) {
      setActive(0);
    } else {
      setActive(active + 1);
    }
  }, [active]);

  const renderWishlist = () => {
    return mensajes.map((w, index) => <WishesItem key={index} {...w} isActive={index === active} />);
  };

  /** Side effect to autoscroll */
  useEffect(() => {
    const interval = setInterval(() => {
      if (!pauseSlide) {
        handleSetNext();
      } else {
        clearInterval(interval);
      }
    }, INTERVAL_SLIDE);

    return () => clearInterval(interval);
  }, [handleSetNext, pauseSlide]);

  useEffect(() => {
    fetch(`https://scarletteywaldemar.up.railway.app/api/mensajes`)
  .then(res => res.json())
  .then(data => {
    setMensajes(data.id);
    setLoad(false);
    // hacer algo con los datos recibidos
  })
  .catch(err => console.error(err));

  }, []);
  return (
      !load &&(
    <div className="wrap-testimony">
        {renderWishlist()}
      <div css={styButtonWrapper}>
        <button className="btn btn-sm button-nav" onClick={() => handleSetActive(false)}>{`< Anterior`}</button>
        <button className="btn btn-sm button-nav" onClick={() => handleSetActive(true)}>{`Siguiente >`}</button>
      </div>
      <br></br>
      <div css={styButtonWrapper}>
        <Link to={`/send-wishes?${codeLink}`}>
          <button className="btn btn-default btn-block">Escribe un mensaje</button>
        </Link>
      </div>
      <br></br>
      <div css={styButtonWrapper}>
      </div>
      </div>
      )
  );
}

WishesContainer.propTypes = {
  codeLink: string.isRequired,
};

export default React.memo(WishesContainer);
